export interface ILogisticsDates {
    surgeryPickUpTime: string,
    surgeryPickUpTimeTz: string,
    departureTime: string, 
    departureTimeTz: string, 
    arrivalTime: string,   
    arrivalTimeTz: string,
    leg2DepartureTime: string,
    leg2DepartureTimeTz: string,
    leg2ArrivalTime: string,
    leg2ArrivalTimeTz: string,
    kidneyArrivalTime: string,
    kidneyArrivalTimeTz: string,
    tenderedTime?: string,
    tenderedTimeTz?: string,
    recoveredTime?: string,
    recoveredTimeTz?: string,
}